export function accessObjectByPathHelper(path: string, obj: any) {

    const pathArray = path.split('.');

    return pathArray.reduce((subObj, currentKey) => {
        if (subObj && (subObj[currentKey] !== null || subObj[currentKey] !== undefined)) {
            return subObj[currentKey];
        } else {
            return null;
        }
    }, obj);
}
